import { View } from "binder"
import { CreateInstanceViewModel } from "./createInstance-viewModel"

export class CreateInstanceView extends View<CreateInstanceViewModel>{
    GetViewUniqueId(): string {
        return "V-DF8FB998-5505-4459-B303-A5BB9C113390"
    }
    loadHtml(): string {
        let element = require('./createInstance.html').default;
        let style = require('./createInstance.less');
        return element;
    }
    constructor() {
       super();
    }
    public set type(v: string) { this._type = v; } public get type(): string { return this._type;} private _type: string;
    public set variableName(v: string) { this._variableName = v; } public get variableName(): string { return this._variableName;} private _variableName: string;

}
